import { useState, useEffect, useContext } from 'react';
import { FetchContext } from './context.js';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';


export default function LifeBar(){
  const nwsFetch = useContext(FetchContext);
  const [volPercent, setVolPercent] = useState({used: 0, limit: 0, perc: 0});
  const [nestingPercent, setNestingPercent] = useState({used: 0, limit: 0, perc: 0});
  useEffect(()=>{
    nwsFetch("/api/usage/").then(async (response) => {
      if(response.ok){
        const data = await response.json();
        setVolPercent({
          used: data.mb_usage,
          limit: data.mb_limit,
          perc: data.mb_usage / data.mb_limit
        });
        let nesting_limit;
        let nesting_perc;
        if(data.nesting_limit === -1){
          nesting_limit = "Unlimited";
          nesting_perc = 0;
        }else{
          nesting_limit = data.nesting_limit;
          nesting_perc = data.nesting_usage / data.nesting_limit
        }
        setNestingPercent({
          used: data.nesting_usage,
          limit: nesting_limit,
          perc: nesting_perc,
        });
      }
    });
  }, [setVolPercent, setNestingPercent, nwsFetch]);
  const linearStyle = {
    height: "100%",
    position: 'absolute',
    width: "500px",
    fontSize: "0.8rem",
    textAlign: "center",
  }
  return (
    <>
      <Container sx={{display: "flex", width: "500px"}}>
          <Box sx={{position: 'relative', width: "500px", height: 20, marginBottom: "4px"}}>
            <LinearProgress variant="determinate" value={volPercent.perc*100} sx={linearStyle}/>
            <Typography sx={linearStyle}>{volPercent.used} / {volPercent.limit} MB used</Typography>
          </Box>
      </Container>
      <Container sx={{display: "flex", width: "500px"}}>
          <Box sx={{position: 'relative', width: "500px", height: 20}}>
            <LinearProgress variant="determinate" value={nestingPercent.perc*100}  sx={linearStyle}/>
            <Typography sx={linearStyle}>{nestingPercent.used} / {nestingPercent.limit} minutes used</Typography>
          </Box>
      </Container>
    </>
  )
}
